import React, {useEffect, useState} from 'react';
import {observer} from "mobx-react";
import {useStores} from "../../../stores/Context";
import WidgetConsignesContentHistory from "../WidgetConsignes/views/WidgetConsignesContentHistory";
import WidgetConsignesContentHome from "../WidgetConsignes/views/WidgetConsignesContentHome";
import WidgetConsignesContentPhoto from "../WidgetConsignes/views/WidgetConsignesContentPhoto";
import WidgetConsignesContentAdd from "../WidgetConsignes/views/WidgetConsignesContentAdd";
import WidgetConsignesContentParametres from "./views/WidgetConsignesContentParametres";
import SidebarWidgets from "../../SidebarWidgets/SidebarWidgets";

const WidgetConsignesContent = observer(() => {
    const {consignesStore} = useStores();


  // const handleGoHome = (event) => {
  //     event.preventDefault();
  //     consignesStore.handleViewHome()
  // }

        return (
            <div className={"contentNiv1 contentNiv1Consignes"}>
                <SidebarWidgets widget={"consignes"}/>

                <div className={"consigneView"}>

                    <WidgetConsignesContentHome />

                    {
                      // consignesStore.viewHome !== true ? (
                      //     <div className={"retourHomeBtn"} onClick={handleGoHome}>
                      //         <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                      //             <path d="M10 10L31.2903 31.2903" stroke="#002335" stroke-width="4" stroke-linecap="round"
                      //                   stroke-linejoin="round"/>
                      //             <path d="M10 31.2891L31.2903 9.99874" stroke="#002335" stroke-width="4"
                      //                   stroke-linecap="round" stroke-linejoin="round"/>
                      //         </svg>
                      //     </div>
                      // ) : null
                    }

                    {
                    // consignesStore.viewPhoto ? (
                    //     <WidgetConsignesContentPhoto/>
                    // ) : consignesStore.viewAddConsigne ? (
                    //     <WidgetConsignesContentAdd handleViewHome={() => consignesStore.handleViewHome()}
                    //                                updateConsigne={consignesStore.consigneData}/>
                    // ) : consignesStore.viewHistory ? (
                    //     <WidgetConsignesContentHistory/>
                    // ) : consignesStore.viewParametre ? (
                    //     <WidgetConsignesContentParametres/>
                    // ) : (
                    //     <WidgetConsignesContentHome handleUpdateConsigne={(data) => {
                    //         consignesStore.handleViewAddConsigne(data)
                    //     }}/>
                    // )
                    }
                </div>
            </div>

        );
    }
);

export default WidgetConsignesContent;